module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#bundle",
      toString: function () {
        return this.url;
      }
    }